/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Go_To_My_FilesInputs */

const en_common_go_to_my_files = /** @type {(inputs: Common_Go_To_My_FilesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Go to my files`)
};

const es_common_go_to_my_files = /** @type {(inputs: Common_Go_To_My_FilesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ir a mis archivos`)
};

/**
* | output |
* | --- |
* | "Go to my files" |
*
* @param {Common_Go_To_My_FilesInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const common_go_to_my_files = /** @type {((inputs?: Common_Go_To_My_FilesInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Go_To_My_FilesInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_common_go_to_my_files(inputs)
	return en_common_go_to_my_files(inputs)
});